import axios, { AxiosInstance } from "axios";
import { AuthenticationRequest } from "../models/3ds2.model";

class ThreeDSecure2Service {
    private readonly client: AxiosInstance;

    constructor() {
        this.client = axios.create({
            baseURL: 'https://pgb.realgrowsoft.com/',
            // baseURL: 'http://192.168.100.169:8080/',
            // timeout: 10000,
            headers: {
                'Content-Type': 'application/json',
            }
        });

    }


    getToken(apiKey: string, merchantId: string, midName: string) {
        return this.client.post(`ng/getToken/${merchantId}/${midName}`, undefined, {
                headers: {
                    'x-api-key': apiKey,
                },
            });
    }
    
    sendBrowserDetails(body: AuthenticationRequest,apiKey: string, merchantId: string, midName: string, transactionId: string) {
        return this.client.post(`/ng/sendBrowserDetails/${merchantId}/${midName}/${transactionId}`, body, {
                headers: {
                    'x-api-key': apiKey,
                },
            })
    }

    postbackToClient(transactionId: string, postbackUrl: string) {
        return this.client.post(`ng/postbackToClient?internalTransactionId=${transactionId}&postbackUrl=${postbackUrl}`)
    }

}

const threeDSecure2Service = new ThreeDSecure2Service();

export { threeDSecure2Service }